<template>
    <div
        class="modal-card"
        style="height: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Apply Access Group to new Library
            </p>
        </header>
        <section
            class="modal-card-body">
            <b-field label="Library">
                <b-select
                    v-model="selectedLibrary"
                    :loading="!allLibraries"
                    placeholder="Select Library">
                    <option
                        v-for="lib in allLibraries"
                        :key="lib.name">
                        {{ lib.name }}
                    </option>
                </b-select>
            </b-field>
        </section>
        <footer class="modal-card-foot">
            <div class="buttons">
                <button
                    class="button"
                    @click="closeModal">
                    <b-icon
                        icon="close-circle"
                        size="is-small" />
                    <span>
                        Cancel
                    </span>
                </button>
                <button
                    class="is-primary button"
                    :disabled="doneDisabled"
                    @click="done">
                    <span class="icon is-small">
                        <i
                            class="mdi mdi-check-circle"
                            aria-hidden="true" />
                    </span>
                    <span>
                        Add Library
                    </span>
                </button>
            </div>
        </footer>
    </div>
</template>

<script>

    import { getLibraries, postAccessGroupLibrary } from '@/shared/helpers/api.ts';

    export default {
        props: {
            accessGroup: {
                type: String,
                required: true
            }
        },
        emits: [
            'change',
            'close'
        ],
        data() {
            return {
                allLibraries: null,
                selectedLibrary: null,
                allScopes: null,
                selectedScope: null
            };
        },
        computed: {
            doneDisabled() {
                return !this.selectedLibrary;
            }
        },
        async mounted() {
            this.allLibraries = await getLibraries(this);
        },
        methods: {
            async done() {
                await postAccessGroupLibrary(this, this.accessGroup, this.selectedLibrary);
                this.$emit('change');
                this.closeModal();
            },
            closeModal() {
                this.$emit('close');
            }
        }
    };
</script>
